import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";
import {
  isActiveLink,
  isActiveParentChild,
} from '../../utils/linkActiveChecker';
import mobileMenuData from '../../data/mobileMenuData';
import mobileMenuDataLahalle from '../../data/mobileMenuDataLahalle';
import mobileMenuDataIncluvia from '../../data/mobileMenuDataIncluvia';
import ContactModal from "../ContactModal";

const HeaderNavContent = ({page}) => {
    const location = useLocation();
    const menuMapping = {
        lahalle: mobileMenuDataLahalle,
        incluvia: mobileMenuDataIncluvia,
    };

    const menuData = menuMapping[page] || mobileMenuData;
    const menuClassMapping = {
        lahalle: "menu-lahalle",
        incluvia: "menu-lahalle",
    };
  return (
      <nav className={`nav main-menu ${menuClassMapping[page] || ""}`}>
        <ul className="navigation" id="navbar">

          {menuData.map((item, index) => (
            item.items && item.items.length > 0 ? (
              <li
                  key={`menu-${item.id}` || `menu-${index}`}
                className={`${item.class ? item.class : ""} dropdown ${isActiveParentChild(item.items, location.pathname) ? "current" : ""}`}
              >
                <span>{item.label}</span>
                <ul>
                  {item.items.map((subItem) => (
                    <li
                      key={subItem.routePath}
                      className={location.pathname.includes(subItem.routePath) ? "current" : ""}
                    >
                      <NavLink to={subItem.routePath}>{subItem.name}</NavLink>
                    </li>
                  ))}
                </ul>

              </li>
            ) : (
              <li
                key={`menu-${item.id}` || `menu-${index}`}
                className={`${item.class ? item.class : ""}${isActiveLink(item.routePath, location.pathname) ? " current" : ""}`}
              >
                  {item.reserved ? (
                      <ContactModal textButton={item.label}
                                    showText={false}
                                    small="small"
                                    linkPageContact={false}
                                    iframe={true}
                                    couleur={false}
                                    designBtn={false}
                                    iconMenu={item.icon}
                                    page={page}
                      />
                  ) : item.infos ? (
                      <ContactModal textButton={item.label}
                                    showText={false}
                                    small="small"
                                    linkPageContact={false}
                                    iframe={false}
                                    designBtn={false}
                                    iconMenu={item.icon}
                                    page={page}
                      />
                  ) : item.faq ? (
                      <ContactModal textButton={item.label}
                                    showText={false}
                                    small="small"
                                    linkPageContact={false}
                                    iframe={false}
                                    designBtn={false}
                                    iconMenu={item.icon}
                                    page={page}
                                    faq={true}
                      />
                  ): (
                      <>
                        {item.routePath.startsWith("#") ? (
                            <HashLink smooth to={item.routePath} >
                                {item.icon ? (
                                    isActiveLink(item.routePath, location.pathname)
                                        ? <><img src={item.iconActive} alt={item.label} width="20" /> {item.label}</>
                                        : <><img src={item.icon} alt={item.label} width="20" /> {item.label}</>
                                ) : (
                                    item.label
                                )}
                            </HashLink>
                          ) : (
                              <NavLink to={item.routePath}>
                                  {item.icon ? (
                                      isActiveLink(item.routePath, location.pathname)
                                          ? <><img src={item.iconActive} alt={item.label} width="20" /> {item.label}</>
                                          : <><img src={item.icon} alt={item.label} width="20" /> {item.label}</>
                                  ) : (
                                      item.label
                                  )}
                              </NavLink>
                          )}
                      </>
                  )}
              </li>
            )
          ))}
        </ul>
      </nav>
    );
  };


export default HeaderNavContent;
